import { inject, Injectable } from "@angular/core";
import { Translation, TranslocoLoader } from "@jsverse/transloco";
import { HttpClient } from "@angular/common/http";
import { environment } from "../environments/environment";

declare global {
    interface Window {
        __packageInfo__?: {
            version?: string;
        };
    }
}

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
    private http = inject(HttpClient);
    private readonly appVersion: string;

    constructor() {
        // Initialize version once during construction
        this.appVersion = this.getAppVersion();
    }

    getTranslation(lang: string) {
        const url = `${environment.baseHref}assets/i18n/${lang}.json?v=${this.appVersion}`;
        return this.http.get<Translation>(url);
    }

    private getAppVersion(): string {
        // Priority order for version resolution:
        
        // 1. Use environment version (set during build)
        if (environment.appVersion && environment.appVersion !== 'BUILD_VERSION_PLACEHOLDER') {
            return environment.appVersion;
        }
        
        // 2. Use build timestamp from meta tag (if available)
        const buildTimestamp = document.querySelector('meta[name="build-timestamp"]')?.getAttribute('content');
        if (buildTimestamp !== null && buildTimestamp !== undefined) {
            return buildTimestamp;
        }
        
        // 3. Use package info from window global (if available)
        const packageInfo = window.__packageInfo__;
        if (packageInfo !== undefined && packageInfo !== null && packageInfo.version !== undefined) {
            return packageInfo.version;
        }
        
        // 4. Fallback to a default version (avoid dynamic timestamps)
        return '1.0.0';
    }
}
